<template>
    <div>
        <b-modal v-model="showEditAvaialabilityModal" no-close-on-backdrop hide-footer no-close-on-esc size="md">
            <template #modal-header style="padding: 0; margin: 0;">
                <div class="d-flex w-100 border-bottom pb-0">
                    <h2 align-v="start" class="w-100 text-left pb-2">
                        Bloquear <span style="color: #12576e">{{ formatDate(selectedDate, "DD [de] MMMM [de] YYYY") }}</span>
                    </h2>

                    <div class="text-right pb-0">
                        <button @click.prevent="closeModal()" type="button" class="close" aria-label="Fechar">
                            <span @click.prevent="closeModal()" class="no no-e-remove"></span>
                        </button>
                    </div>
                </div>
            </template>

            <div v-if="poisList.length > 0" class="pt-0">
                <b-row v-for="(poi, idx) in poisList.filter(poi => ['Passeio', 'Experiência','Evento'].includes(poi.type))" :key="idx" class="pb-3" align-h="between">
                    <b-col>
                        <span :style="{'text-decoration': isPoiAvaialable(poi.unavailability) ? 'none' : 'line-through' }">
                            {{ poi.product_name }}
                        </span>
                    </b-col>

                    <b-col cols="3">
                        <b-button @click.prevent="editAvaialability(poi)" :variant="isPoiAvaialable(poi.unavailability) ? 'outline-danger' : 'success'" size="sm">
                            {{ isPoiAvaialable(poi.unavailability) ? 'Bloquear' : 'Desbloquear' }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import swal from "sweetalert2"

export default {
    name: 'ModalEditarDisponibilidade',

    components:{

    },

    props:{
        showEditAvaialabilityModal: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapGetters('product', {
            poisList: 'getPois',
        }),

    },

    inject: ['isLoading', 'selectedDate'],

    watch: {

    },

    data() {
        return {

        }
    },

    methods: {
        ...mapActions('operacao', [
            'blockDayProduct',
            'unblockDayProduct',
        ]),

        formatDate(date, format){ return moment(date).format(format) },

        closeModal(){ this.$emit('emitCloseAvaialabilityModal') },

        isPoiAvaialable(unavailability){
            const unavailabilityKeys = Object.keys(unavailability)
            return !unavailabilityKeys.includes(this.selectedDate)
        },

        editAvaialability(poi){
            if(this.isPoiAvaialable(poi.unavailability)){ this.blockDay(poi) }
            else{ this.unblockDay(poi) }
        },

        blockDay(poi){
            const dayToBlock = this.formatDate(this.selectedDate, "DD/MM/YYYY")
            swal.fire({
                title: `Bloquear o dia ${dayToBlock} ?`,
                text: `${poi.product_place_name}: ${poi.product_name}`,
                showCancelButton: true,
                confirmButtonText: 'Bloquear',
                confirmButtonColor: '#D93051',
                cancelButtonText: 'Fechar',
                reverseButtons: true,
                cancelButtonColor: 'secondary',
                type: 'default'
            })
            .then((result => {
                if (result.isConfirmed) {
                    const unavailability = { [this.selectedDate]: [{ ticket: "*" }] }
                    this.blockDayProduct({ product_uuid: poi.uuid, unavailability: unavailability })
                    this.$notify({
                      message: 'Reservas bloqueadas para: ' + dayToBlock,
                      duration: 6000,
                      type:'success'
                    })
                    this.$emit("emitReloadPois")
                }
            }))
        },

        unblockDay(poi){
            swal.fire({
                title: `Desbloquear o dia ${this.formatDate(this.selectedDate, "DD/MM/YYYY")} ?`,
                text: `${poi.product_place_name}: ${poi.product_name}`,
                showCancelButton: true,
                confirmButtonText: 'Desbloquear',
                confirmButtonColor: '#A7AA37',
                cancelButtonText: 'Fechar',
                reverseButtons: true,
                cancelButtonColor: 'secondary',
                type: 'default'
            })
            .then((result => {
                if (result.isConfirmed) {
                    const unavailability = { [this.selectedDate]: [{ ticket: "*" }] }
                    this.unblockDayProduct({ product_uuid: poi.uuid, unavailability: unavailability })
                    this.$emit("emitReloadPois")
                }
            }))
        },

    },

    mounted(){

    },

}
</script>
